import { render, staticRenderFns } from "./49.vue?vue&type=template&id=0a201722&scoped=true&"
import script from "./49.vue?vue&type=script&lang=js&"
export * from "./49.vue?vue&type=script&lang=js&"
import style0 from "./49.vue?vue&type=style&index=0&id=0a201722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a201722",
  null
  
)

export default component.exports